import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { Http, URLSearchParams } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from './tools/errors.service';

@Injectable()
export class ConveniosService {

  private service_url : string = '';
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService, 
      private validatorService: ValidatorService, 
      private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/convenios';
  }

  public getAll(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.paginate){
      myParams.append('paginate', 'true');
    }

    if(filters.page){
      myParams.append('page', filters.page);
    }

    if(filters.search){
      myParams.append('search', filters.search);
    }

    if(filters.order){
      myParams.append('order', filters.order);
    }

    if(filters.tipo){
      myParams.append('tipo', filters.tipo);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    return this.http.get(this.service_url , myoptions);
  }

  public get(id : number) {
    return this.http.get(this.service_url + '/' + id, this.authService.getAuthHeaders());
  }

  public save(credito : object) {
    return this.http.post(this.service_url , credito, this.authService.getAuthHeaders());
  }

  public update( credito : object) {
    return this.http.put(this.service_url , credito, this.authService.getAuthHeaders());
  }

  public delete(idConvenio : number) {
    return this.http.delete(this.service_url + '/' + idConvenio, this.authService.getAuthHeaders());
  }

  public validate(convenio : any){
    let error = [];

    if(!this.validatorService.required(convenio.razon_social)){
        error["razon_social"] = this.errorService.required;
    }

    if(!this.validatorService.required(convenio.nombre_comercial)){
        error["nombre_comercial"] = this.errorService.required;
    }

    if(!this.validatorService.required(convenio.rfc)){
        error["rfc"] = this.errorService.required;
    }

    if(!this.validatorService.required(convenio.direccion)){
        error["direccion"] = this.errorService.required;
    }

    if(!this.validatorService.required(convenio.telefono)){
        error["telefono"] = this.errorService.required;
    }

    if(!this.validatorService.required(convenio.tasa_interes)){
        error["tasa_interes"] = this.errorService.required;
    }

    if(!this.validatorService.required(convenio.calculo)){
        error["calculo"] = this.errorService.required;
    }

    if(convenio.periodicidad === null || convenio.periodicidad === undefined || convenio.periodicidad === ''){
        error["periodicidad"] = this.errorService.required;
    }

    if(convenio.endeudamiento_max === null || convenio.endeudamiento_max === undefined || convenio.endeudamiento_max === ''){
      error["endeudamiento_max"] = this.errorService.required;
    }

    return error;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/convenios.service.ts